import Honeybadger from 'honeybadger-js'
window.Honeybadger = Honeybadger

export default Honeybadger
